import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, XCircleIcon, LayersIcon, ShieldIcon } from 'lucide-react';
const benefits = [{
  icon: ZapIcon,
  title: 'Fast Approvals',
  description: 'Approved in 24-48 hours. Period.'
}, {
  icon: XCircleIcon,
  title: 'No Bank Requirements',
  description: 'Banks said no? We say yes.'
}, {
  icon: LayersIcon,
  title: 'Multiple Funding Options',
  description: "Loans, credit lines, equipment financing, MCAs — we've got it all."
}, {
  icon: ShieldIcon,
  title: 'Soft Pull Pre-Qualification',
  description: 'Zero impact on your credit score to check.'
}];
export function BenefitsSection() {
  const scrollToForm = () => {
    document.getElementById('qualify-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 px-4 bg-black" data-id="element-18">
      <div className="max-w-7xl mx-auto" data-id="element-19">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-5xl text-center mb-10" data-id="element-20">
          Why Business Owners Choose Cotifunding
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-21">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={benefit.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-charcoal border border-gray-800 rounded-xl p-8 hover:border-gold-primary/50 transition-all duration-300" data-id="element-22">
                <Icon className="w-12 h-12 text-gold-primary mb-4" data-id="element-23" />
                <h3 className="text-2xl font-bold mb-2" data-id="element-24">{benefit.title}</h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-25">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-26">
          <button onClick={scrollToForm} className="bg-gold-primary text-black font-bold text-lg md:text-xl px-10 py-4 rounded-lg hover:bg-gold-accent transition-all duration-300 hover:shadow-[0_0_30px_rgba(240,185,11,0.4)]" data-id="element-27">
            See If You Qualify in 60 Seconds (No Impact on Your Credit) →
          </button>
        </motion.div>
      </div>
    </section>;
}